import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { Edit } from '@insurancemenu/imenu-components-lib/dist/icons';
import EditNotesModal from 'components/group-info/EditNotesModal';
import { useRootStore } from 'store/rootStore';
import { createStyles } from './styles';

interface NotesProps {
  employerGroupId?: string;
}

const Notes = observer(({ employerGroupId }: NotesProps): JSX.Element => {
  // React local state
  const [showModal, setShowModal] = React.useState(false);

  // Mobx store
  const rootStore = useRootStore();
  const {
    groupSidebarStore: {
      group: { notes },
    },
  } = rootStore;

  const editNotes = (): void => {
    setShowModal(true);
  };

  const classes = createStyles();
  return (
    <>
      <header className={classes.categoryWrapper}>
        <h3 className={classes.categoryName}>Notes</h3>
        <Button
          id="edit-notes"
          type="text"
          iconSize="1.6rem"
          color="custom"
          customColor={colors.neutral[900]}
          leftIconProp={<Edit />}
          className={classes.editNotes}
          onClick={(): void => editNotes()}
        >
          {' '}
        </Button>
      </header>
      <div>
        <div id="notes-info" className={classes.notesText}>
          {notes}
        </div>
      </div>
      <EditNotesModal
        employerGroupId={employerGroupId || ''}
        show={showModal}
        onClose={(): void => setShowModal(false)}
      />
    </>
  );
});

export default Notes;
